module.exports = __webpack_public_path__ + "img/tzfardea_no.e323d9b7.png";